import { useEffect, useState } from "react";
import { CHAPTER_PAGE_NAMES } from "../../chapterRegistry";

const useMenu = ({ currentPageName, chapterComplete, setChapterComplete, onResetPages }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [isMenuRetract, setIsMenuRetract] = useState(true);

  useEffect(() => {
    const isAllowed = CHAPTER_PAGE_NAMES.includes(currentPageName);
    setShowMenu(isAllowed);

    if (!isAllowed) {
      setIsMenuRetract(true);
    }
  }, [currentPageName]);

  useEffect(() => {
    if (chapterComplete) {
      setIsMenuRetract(true);
    }
  }, [chapterComplete]);

  const handleOnReset = () => {
    setChapterComplete(true);
    onResetPages();
  };

  const toggleMenu = () => {
    setIsMenuRetract((prevIsMenuRetract) => !prevIsMenuRetract);
  };

  return {
    showMenu,
    isMenuRetract,
    handleOnReset,
    toggleMenu,
  };
};

export default useMenu;
